<div>
    <form nz-form #clientMasterPage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Task</nz-form-label>

                    <nz-form-control>
                        <nz-select name="task" nzShowSearch nzAllowClear nzPlaceHolder="Select a Task" [(ngModel)]="data.TASK_ID">
                            <nz-option *ngFor="let task of taskList" [nzValue]="task.ID" [nzLabel]="task.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>To</nz-form-label>

                    <nz-form-control>
                        <nz-select name="toUser" nzShowSearch nzAllowClear nzPlaceHolder="Select a User Transfer To" [(ngModel)]="data.TO_USER_ID">
                            <nz-option *ngFor="let toUser of toUserList" [nzValue]="toUser.ID" [nzLabel]="toUser.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID" (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="!data.ID" nz-dropdown [nzDropdownMenu]="menu" (click)="save(false)"><span>Save & Close</span></button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
                <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                    <a (click)="save(true)">Save & New</a>
                </li>
            </ul>
        </nz-dropdown-menu>
    
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(clientMasterPage)"><span>Reset</span></button>
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="close(clientMasterPage)"><span>Cancel</span></button>
</div>